import { X } from "lucide-react";
import type { ReactNode } from "react";

export interface BulkActionsBarProps {
  /** Number of selected items */
  selectedCount: number;
  /** Callback to clear the selection */
  onClear: () => void;
  /** Action buttons to display */
  children: ReactNode;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Fixed bottom bar showing selected items count and action buttons.
 * Returns null when nothing is selected.
 */
export function BulkActionsBar({
  selectedCount,
  onClear,
  children,
  className = "",
}: BulkActionsBarProps) {
  if (selectedCount === 0) return null;

  return (
    <div
      className={`fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-4xl px-4 ${className}`}
    >
      <div className="alert alert-info shadow-lg flex items-center justify-between">
        <div className="flex items-center gap-4">
          <span className="font-semibold">
            {selectedCount} élément{selectedCount > 1 ? "s" : ""} sélectionné
            {selectedCount > 1 ? "s" : ""}
          </span>
        </div>

        <div className="flex items-center gap-2">
          {children}

          <div className="divider divider-horizontal mx-2" />

          <button
            type="button"
            className="btn btn-sm btn-ghost gap-2"
            onClick={onClear}
            title="Effacer la sélection"
          >
            <X className="w-4 h-4" />
            Effacer
          </button>
        </div>
      </div>
    </div>
  );
}
